module.exports = __webpack_public_path__ + "pumpmylead.jpg?70c62df13909bd295c1d4516f94da2a4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/projetos/pumpmylead.jpg
// module id = 149
// module chunks = 0